import { Box, Typography } from "@mui/material";
import { useCurrentCustomer } from "../root/CurrentOrganisationProvider";

export const SelectedPersonalDataControllerHint = ({ label, name }: { label: string; name?: string }) => {
  const currentCustomer = useCurrentCustomer();

  if (currentCustomer.customerKind === "enterprise" || !name) return null;

  return (
    <Box sx={{ position: "absolute", bottom: 0, transform: "translateY(100%)" }}>
      <Typography
        sx={{ fontSize: theme => theme.typography.pxToRem(12), mt: 1, color: theme => theme.palette.text.secondary }}
      >
        {label}:{" "}
        <Box component="span" sx={{ fontWeight: 600 }}>
          {name}
        </Box>
      </Typography>
    </Box>
  );
};
